export enum UiSpinnerFeatureKey {
  Global = 'Global',
}

export enum Locale {
  En = 'en',
  Ar = 'ar',
}
